import React from 'react';
import { JsonPropsType } from '../../component-loader';
import { Endpoint, EndpointGroup } from './types';

interface PlaygroundAppProps {
  endpoints: Endpoint[];
}

function EndpointRow({ endpoints }: { endpoints: Endpoint[] }) {
  return (
    <div className="row g-3">
      {endpoints.map((endpoint) => (
        <div key={endpoint.slug} className="col-md-6 col-lg-4">
          <div className="card h-100">
            <div className="card-body d-flex flex-column">
              <h5 className="card-title">{endpoint.name}</h5>
              <code className="d-block mb-3 text-secondary small">
                POST
                {' '}
                {endpoint.path}
              </code>
              <a
                href={`/playground/${endpoint.slug}/`}
                className="btn btn-primary btn-sm mt-auto align-self-start"
              >
                Probar
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

const byGroup = (endpoints: Endpoint[], group: EndpointGroup) => endpoints.filter(
  (endpoint) => endpoint.group === group,
);

export function PlaygroundApp(props: JsonPropsType) {
  const { endpoints } = props.jsonObject as PlaygroundAppProps;
  const savingsEndpoints = byGroup(endpoints, 'insurance_with_savings');
  const apvEndpoints = byGroup(endpoints, 'insurance_with_apv');

  return (
    <div className="playground-app">
      <p className="text-muted">
        Endpoints disponibles
      </p>
      {savingsEndpoints.length > 0 && (
        <div className="mb-5">
          <EndpointRow endpoints={savingsEndpoints} />
        </div>
      )}
      {savingsEndpoints.length > 0 && apvEndpoints.length > 0 && (
        <hr className="mb-5 opacity-25" />
      )}
      {apvEndpoints.length > 0 && (
        <EndpointRow endpoints={apvEndpoints} />
      )}
    </div>
  );
}
